<template>
  <withTopNav :leftText="t('Activities.Vip.LeftText')" class="vipHistory" fixed>
    <div class="dTable">
      <div class="title">
        <img src="@a/assets/images/i_bonus.png" class="size-7" alt="">
        <h3> {{ t('Activities.Vip.CollectionRegistration') }}</h3>
      </div>
      <DataTable :columns :data="tableData" headBgColor="var(--odd-bg-color)" :bodyBgColor="['var(--even-bg-color)', 'var(--odd-bg-color)']" />
    </div>
  </withTopNav>
</template>

<script setup lang="tsx">
  import withTopNav from '@/layouts/withTopNav.vue'
  import DataTable from '@a/components/DataTable/index.vue'
  import { getVipHistory } from '@/api'
  import dayjs from 'dayjs'
  import { formatter } from '@/utils'
  import { useI18n } from 'vue-i18n';
  const { t } = useI18n();
  const vTypes = {
    'Upgrade': t('Activities.Vip.UpgradePrize'),
    'Month': t('Activities.Vip.MonthlyBonus'),
    'Week': t('Activities.Vip.WeeklyBonus'),
    }

  const columns = [
    {
      title: t('Activities.Vip.CollectionTime'),
      key: 'k1',
      headClass: '!text-15',
      render: (row) => {
        return <div>{ dayjs.utc(row.collectTime).local().format('MM/DD HH:mm') }</div>
      }
    },
    {
      title: t('Activities.Vip.Event'),
      key: 'k2',
      headClass: '!text-15',
      bodyClass: 'text-11',
      render: (row) => {
        return <div>{vTypes[row.rewardType] || ''}</div>
      }
    },
    {
      title: t('Activities.Vip.Money'),
      key: 'k3',
      headClass: '!text-15',
      render: (row) => {
        return <div class="text-13 text-[var(--theme-primary)]">{formatter().format(row.rewardAmount)}</div>
      }
    }
  ];

  const tableData = ref([]);
  const pageIndex = ref(0);

  onMounted(async () => {
    const { code, data } = await getVipHistory({ pageIndex: pageIndex.value, pageSize: 30 })
    console.log("🚀 ~ onMounted ~ data:", data)
    if (code === 1) {
      tableData.value = data.data
    }
  })
</script>

<style lang="scss">
  .vipHistory {
    .dTable{
      @apply m-[24px_16px] overflow-hidden rounded-8 text-13 font-[500];
    }

    .title{
      @apply flex-center-y gap-2 bg-[var(--title-bg-color)] px-3 h-11 mb-0.5 text-15 font-[600];
    }
  }
</style>
